import React from 'react';
import { isDesktop } from '@direct-frontend/platform-code';

import { SelectStub } from '../Select/SelectStub';
import { ListBoxOptionItem } from '../ListBox';

import { SelectCompactTrigger, CompactTriggerProps } from './SelectCompact';

const emptyValue: ListBoxOptionItem<string>[] = [];

type SelectCompactStubProps<ValueType extends string> = Omit<
    CompactTriggerProps<ValueType>,
    'value' | 'placeholder' | 'isOpened' | 'isStub' | 'isTruncated'
>;

/**
 * Компонент для отображения состояния загрузки компонента SelectCompact
 * @kind component
 */
export function SelectCompactStub<ValueType extends string>(props: SelectCompactStubProps<ValueType>) {
    const { width = 'auto' } = props;
    return isDesktop() ? (
        <SelectCompactTrigger {...props} width={width} isStub value={emptyValue} />
    ) : (
        <SelectStub {...props} width={width} />
    );
}
